<template>
  <Breadcrumbs :breadcrumbs="breadcrumbs" />
</template>

<script setup lang="ts">
import {
  EventListPageType,
  type StrapiEventListPage,
} from '~/composables/types/strapiEventListPage'
const {
  type,
  eventListPageObj,
  categorySlug,
  citySlug,
  cityName,
  generalSlug,
} = defineProps<{
  type: EventListPageType
  categorySlug?: string
  citySlug?: string
  tagSlug?: string
  generalSlug?: string
  eventListPageObj: StrapiEventListPage
  cityName?: string
}>()

const { t } = useI18n()

const pageSlug = {
  [EventListPageType.CITY]: citySlug,
  [EventListPageType.GENERAL]: generalSlug,
  [EventListPageType.CATEGORY]: categorySlug,
  [EventListPageType.CITY_CATEGORY]: `${citySlug}_${categorySlug}`,
  [EventListPageType.TEAMEVENT]: `${t(
    'eventListPage.teamEventSlugPrefix'
  )}-${citySlug}`,
  [EventListPageType.SEARCH]: `general`,
  [EventListPageType.KITS]: `kits`,
}[type]

const fullLocalizedUrl = useFullLocalizedUrl()

const breadcrumbs = useState(
  `transactional-page-${type}-${pageSlug}__breadcrumbs`,
  () => [
    {
      text: t('general.home'),
      link: fullLocalizedUrl('/'),
    },
  ]
)

const mountBreadcrumbs = () => {
  if (breadcrumbs.value.length > 1) {
    return
  }

  const routeTranslation = {
    city: '',
    'city-category': '',
    category: '/c',
    general: '/t',
    teamevent: '/teamevent',
    search: '',
    kits: '/kits',
  }

  const citSlug = strapiEventListPageGetters.getSlug(eventListPageObj)

  let link = null

  if (type === 'general') {
    link = fullLocalizedUrl(`${routeTranslation[type]}/${citSlug}`)
  } else if (type === 'category') {
    const category =
      categorySlug ||
      strapiEventListPageGetters.getCategorySlug(eventListPageObj)

    link = fullLocalizedUrl(`${routeTranslation[type]}/${category}`)
  } else {
    const citSlug = citySlug

    link = fullLocalizedUrl(`${routeTranslation[type]}/${citSlug}`)

    if (type === 'city-category') {
      breadcrumbs.value.push({
        text: cityName,
        link,
      })

      const catSlug =
        strapiEventListPageGetters.getCategorySlug(eventListPageObj)

      link = fullLocalizedUrl(`/${citSlug}/${catSlug}`)
    }
  }

  if (type === 'kits') {
    breadcrumbs.value.push({
      text: t('general.kits'),
      link: fullLocalizedUrl('/kits'),
    })

    breadcrumbs.value.push({
      text: strapiEventListPageGetters.getTitle(eventListPageObj),
      link: fullLocalizedUrl(
        `/kits/${strapiEventListPageGetters.getKitsSlug(eventListPageObj)}`
      ),
    })
    return
  }

  breadcrumbs.value.push({
    text: strapiEventListPageGetters.getTitle(eventListPageObj),
    link,
  })
}

mountBreadcrumbs()
</script>
